'use strict';

exports.decode = exports.parse = require('./decode');
exports.encode = exports.stringify = require('./encode');



//////////////////
// WEBPACK FOOTER
// /root/anvel/~/querystring-es3/index.js
// module id = ../../../../querystring-es3/index.js
// module chunks = 4